import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import PaginationLog from "../../Log/PaginationLog";
import { useDispatch, useSelector } from "react-redux";
import { getStatusChanges, selectAll } from "../ad.ducks";
import { formatDate } from "../../../../services/utils";

export interface PriceChangesProps {
  setStatusChangesAdId: (boolean) => void;
  statusChangesAdId: string | null;
  setStatusChangesPostedDate: (value: string | null) => void;
  statusChangesPostedDate: string | null;
}

const PriceChanges = (props: PriceChangesProps) => {
  const {
    statusChangesAdId,
    setStatusChangesAdId,
    statusChangesPostedDate,
    setStatusChangesPostedDate
  } = props;

  const dispatch = useDispatch()
  const allAdmin = useSelector(selectAll)
  const adStatusChanges = allAdmin.adStatusChanges

  const [loading, setIsLoading] = useState(false);

  const loadStatusChanges = (params = {}) => {
    setIsLoading(true);
    dispatch(getStatusChanges(statusChangesAdId, params, () => {
      setIsLoading(false)
    }))

  }

  const handlePageChange = page => {
    loadStatusChanges({ page })
  }

  useEffect(() => {
    if (statusChangesAdId) {
      loadStatusChanges()
    }

  }, [statusChangesAdId])

  const handleClose = () => {
    setStatusChangesAdId(null);
    setStatusChangesPostedDate(null);
  };

  return (
    <Modal
      title="Promjene statusa"
      visible={Boolean(statusChangesAdId)}
      footer={null}
      onCancel={handleClose}
    >
      {statusChangesPostedDate && (
        <p style={{ marginBottom: 12, fontWeight: 500 }}>
          {"Oglas objavljen: "}
          {formatDate(statusChangesPostedDate, "DD.MM.YYYY. HH:mm")}
        </p>
      )}
      <PaginationLog
        columns={[
          {
            title: "Datum",
            dataIndex: 'date',
            key: 'date',
          },
          {
            title: "E-mail",
            dataIndex: 'changedByEmail',
            key: 'changedByEmail',
          },
          {
            title: "Stari status",
            dataIndex: 'oldStatus',
            key: 'oldStatus',
          },
          {
            title: "Novi status",
            dataIndex: 'newStatus',
            key: 'newStatus',
          },
        ]}
        log={adStatusChanges}
        loading={loading}
        emptyLogText={"Nema loga za prikazat."}
        handlePageChange={handlePageChange}
        responsiveProps={{
          xs: 24
        }}
      />

    </Modal>
  );
};

export default PriceChanges;



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAdPage/StatusChanges/StatusChanges.tsx